export enum BalooItemStatusType {
    Deactivated = 0,
    Deleted = 1,
    NoAccessToBaloo = 2,
}
